
const cleanString = (str: string) => {
  let value = str.replaceAll("."," ")

  const cleanKeys:string[] = []
  
  value.replaceAll(" ","-").split("-").forEach(x=>{
    if (x!==""){
      cleanKeys.push(x)
    }
  }) 

  value = cleanKeys.join(" ")
  const reversedValue = value.split(" ").reverse().join(" ");

  return {value, reversedValue}
}

export const compareStringsAccentInsensitive = (str1: string, str2: string): boolean => {

    const {value: value1, reversedValue: reversedValue1} = cleanString(str1)
    const {value: value2, reversedValue: reversedValue2} = cleanString(str2)

    const normalEvaluation  = value1.toLowerCase().localeCompare(value2.toLowerCase(), undefined, { sensitivity: 'base' }) === 0

    const reversedEvaluation = reversedValue1.toLowerCase().localeCompare(reversedValue2.toLowerCase(), undefined, { sensitivity: 'base' }) === 0

    const reversedEvaluation2 = value1.toLowerCase().localeCompare(reversedValue2.toLowerCase(), undefined, { sensitivity: 'base' }) === 0

    const reversedEvaluation3 = reversedValue1.toLowerCase().localeCompare(value2.toLowerCase(), undefined, { sensitivity: 'base' }) === 0

    if (normalEvaluation || reversedEvaluation || reversedEvaluation2 || reversedEvaluation3) {
      return true
    }else{
      return false
    }
  };